module.exports = __webpack_public_path__ + "img/b.211b43c2.jpg";